// Specialty sandwiches data
const SpecialtySandwichPrice = '$'+18.99
const hotDogSandwichPrice = '$9.50'
const veggieSandwichPrice = '$'+9.99
const newYorkerSandwichPrice = '$'+21.99

const specialtySandwiches = [
  {
    id: 1,
    name: 'The Corned Beef Special',
    description: '6oz of Corned Beef, on rye with coleslaw, Swiss cheese and Russian dressing.',
    price: SpecialtySandwichPrice,
    badge: 'Our #1 Seller',
    featured: true
  },
  {
    id: 2,
    name: 'Super Corned Beef',
    description: '6oz of Corned Beef, on rye with lettuce, tomato, Swiss cheese and mayo.',
    price: SpecialtySandwichPrice,
    badge: null,
    featured: false
  },
  {
    id: 3,
    name: 'Super Tuna',
    description: 'Our famous tuna salad on rye with lettuce, tomato, Swiss cheese and mayo.',
    price: SpecialtySandwichPrice,
    badge: null,
    featured: false
  },
  {
    id: 4,
    name: 'The Classic Reuben',
    description: 'Hot corned beef on grilled rye with sauerkraut, melted Swiss cheese and Russian dressing.',
    price: SpecialtySandwichPrice,
    badge: null,
    featured: false
  },
  {
    id: 5,
    name: 'The Uptowner',
    description: 'Smoked turkey on an onion roll with lettuce, tomato, melted Swiss cheese and honey mustard.',
    price: SpecialtySandwichPrice,
    badge: null,
    featured: false
  },
  {
    id: 6,
    name: 'Breakfast Special',
    description: 'Any meat on your choice of bagel or toast with a fried egg and choice of cheese.',
    price: 11.50,
    badge: null,
    featured: false
  },
  {
    id: 7,
    name: 'Dinty Moore',
    description: 'Hot corned beef on triple-decker white toast with lettuce, tomato, and Russian dressing.',
    price: SpecialtySandwichPrice,
    badge: null,
    featured: false
  },
  {
    id: 8,
    name: 'Frisco Chicken',
    description: 'Grilled chicken breast on an onion roll with lettuce, tomato, Cheddar cheese and Ranch dressing.',
    price: SpecialtySandwichPrice,
    badge: null,
    featured: false
  },
  {
    id: 9,
    name: 'Grilled Chicken',
    description: 'Grilled chicken breast on a Kaiser Roll with lettuce, tomato and honey mustard.',
    price: SpecialtySandwichPrice,
    badge: null,
    featured: false
  },
  {
    id: 10,
    name: 'Harry\'s Combo',
    description: 'Hot corned beef and pastrami on an onion roll with Swiss cheese and Russian dressing.',
    price: SpecialtySandwichPrice,
    badge: null,
    featured: false
  },
  {
    id: 11,
    name: 'Hot Dog Special',
    description: 'All beef Hot Dog on a bun with onions, mustard, ketchup and relish.',
    price: hotDogSandwichPrice,
    badge: null,
    featured: false
  },
  {
    id: 12,
    name: 'Lox Bagel Special',
    description: 'Nova lox on choice of bagel with cream cheese, tomato, onion and capers.',
    price: SpecialtySandwichPrice,
    badge: null,
    featured: false
  },
  {
    id: 13,
    name: 'The Star Sub',
    description: 'Rare roast beef on an onion roll with lettuce, tomato, onion, Swiss cheese and Italian dressing.',
    price: SpecialtySandwichPrice,
    badge: null,
    featured: false
  },
  {
    id: 14,
    name: 'Texas Style Roast Beef Brisket',
    description: 'Hot brisket roast beef on rye with onion, American cheese, ketchup and BBQ Sauce.',
    price: SpecialtySandwichPrice,
    badge: null,
    featured: false
  },
  {
    id: 15,
    name: 'Tuna Melt',
    description: '1/3 lb of our famous tuna salad on grilled rye with tomato and melted Swiss cheese.',
    price: SpecialtySandwichPrice,
    badge: null,
    featured: false
  },
  {
    id: 16,
    name: 'Turkey Club',
    description: 'Turkey breast on triple-decker white toast with bacon, lettuce, tomato and mayo.',
    price: SpecialtySandwichPrice,
    badge: null,
    featured: false
  },
  {
    id: 17,
    name: 'The Veggie',
    description: 'Lettuce, tomato on rye with coleslaw, Swiss cheese and Russian dressing.',
    price: veggieSandwichPrice,
    badge: 'Vegetarian',
    featured: false
  },
  {
    id: 18,
    name: 'The Eastsider',
    description: 'Hot corned beef on rye with horseradish, tomato, onion and mayo.',
    price: SpecialtySandwichPrice,
    badge: null,
    featured: false
  },
  {
    id: 19,
    name: 'The Westsider',
    description: 'Hot corned beef and roasted turkey breast on rye with lettuce, tomato, Swiss cheese and Russian dressing.',
    price: SpecialtySandwichPrice,
    badge: null,
    featured: false
  },
  {
    id: 20,
    name: 'The Pastrami Special',
    description: '6oz of Pastrami, on rye with coleslaw, Swiss cheese and Russian dressing.',
    price: SpecialtySandwichPrice,
    badge: null,
    featured: false
  },
  {
    id: 21,
    name: 'The Turkey Special',
    description: '6oz of Turkey, on rye with coleslaw, Swiss cheese and Russian dressing.',
    price: SpecialtySandwichPrice,
    badge: null,
    featured: false
  },
  {
    id: 22,
    name: 'The Super Turkey',
    description: '6oz of Turkey, on rye with lettuce, tomato, Swiss cheese and mayo.',
    price: SpecialtySandwichPrice,
    badge: null,
    featured: false
  },
  {
    id: 23,
    name: 'The New Yorker',
    description: '10oz of Corned Beef, on Onion Roll with Russian Dressing.',
    price: newYorkerSandwichPrice,
    badge: null,
    featured: false
  },
  {
    id: 24,
    name: 'The Whitecap',
    description: 'Smoked whitefish salad with house-made pickled red onions and bell peppers, served on grilled rye bread.',
    price: '$19.99',
    badge: 'New Addition',
    featured: true,
    newAddition: true,
    visualIcon: 'fish'
  },
  {
    id: 25,
    name: 'Philly J',
    description: 'Rare roast beef with melted provolone on grilled rye, sauteed bell peppers and onions, mayo and horseradish.',
    price: '$19.99',
    badge: 'New Addition',
    featured: true,
    newAddition: true,
    visualIcon: 'cheese'
  },
  {
    id: 26,
    name: 'Cuban-esque',
    description: 'Hot ham with melted Swiss cheese on a grilled onion roll with old dill pickle and yellow mustard.',
    price: '$19.99',
    badge: 'New Addition',
    featured: true,
    newAddition: true,
    visualIcon: 'sandwich'
  }
];

export default specialtySandwiches;
